export default __webpack_public_path__ + "static/media/back.77f06d79.png";